import { Button } from '@mui/material';
import React from 'react';
import "./EventPagination.scss";
import { NavigateBeforeRounded, NavigateNextRounded } from '@mui/icons-material';

type PaginationProps = {
  currentPage: number;
  eventsCount: number;
  setCurrentPage: Function
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const { currentPage, eventsCount, setCurrentPage } = props;

  return (
    <div className="pagination-ctn">
      <div className={`pagination-pages `}>
        {currentPage === 1 ? currentPage : currentPage * 20 - 20 + 1} - {currentPage * 20 > eventsCount ? eventsCount : currentPage * 20} of {eventsCount}
      </div>
      <Button
        className={`pagination-btn `}
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <NavigateBeforeRounded />
      </Button>
      <Button
        className={`pagination-btn `}
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage * 20 >= eventsCount}
      >
        <NavigateNextRounded />
      </Button>
    </div>
  )
}

export default Pagination;